var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmileMobile = function SvgSmileMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.7501C15.728 18.7501 18.7501 15.728 18.7501 12C18.7501 8.27201 15.728 5.24988 12 5.24988C8.27201 5.24988 5.24988 8.27201 5.24988 12C5.24988 15.728 8.27201 18.7501 12 18.7501Z",
    stroke: "#737B7E",
    strokeWidth: 1.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97461 14.6996C10.5484 15.1249 11.2471 15.3747 11.9998 15.3747C12.7525 15.3747 13.4511 15.1249 14.0249 14.6996",
    stroke: "#737B7E",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 10.8751C15.0001 11.4961 14.6641 12.0001 14.2501 12.0001C13.8361 12.0001 13.5001 11.4961 13.5001 10.8751C13.5001 10.2541 13.8361 9.75012 14.2501 9.75012C14.6641 9.75012 15.0001 10.2541 15.0001 10.8751Z",
    fill: "#737B7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75012 12.0001C10.1643 12.0001 10.5001 11.4964 10.5001 10.8751C10.5001 10.2538 10.1643 9.75012 9.75012 9.75012C9.33591 9.75012 9.00012 10.2538 9.00012 10.8751C9.00012 11.4964 9.33591 12.0001 9.75012 12.0001Z",
    fill: "#737B7E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmileMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "smile-mobile.3e04b0a6ed1150085dba148f8569f5a9.svg";